import types from './types';

/**
 * Type defs
 * @typedef PendingPhotoApproval
 * @property {String} photoId - group image id of photo
 * @property {String} childId
 */

const getCenterGalleryInformationRequest = centerId => ({
  type: types.GET_CENTER_GALLERY_INFORMATION_REQUEST,
  centerId
});

const getCenterGalleryInformationSuccess = (metricsData, pendingPhotosData) => ({
  type: types.GET_CENTER_GALLERY_INFORMATION_SUCCESS,
  metricsData,
  pendingPhotosData
});

const getCenterGalleryInformationFailure = () => ({
  type: types.GET_CENTER_GALLERY_INFORMATION_FAILURE
});

const getChildGalleryInformationRequest = childId => ({
  type: types.GET_CHILD_GALLERY_REQUEST,
  childId
});

const getChildGalleryInformationSuccess = () => ({
  type: types.GET_CHILD_GALLERY_SUCCESS
});

const getChildGalleryInformationFailure = () => ({
  type: types.GET_CHILD_GALLERY_FAILURE
});

/**
 * Approve provided photos
 * @param {PendingPhotoApproval[]} photoIds
 */
const approvePhotosRequest = photoIds => ({
  type: types.APPROVE_PENDING_PHOTO_REQUEST,
  photoIds
});

/**
 * Success photo approval
 * @param {PendingPhotoApproval[]} photoIds
 */
const approvePhotosSuccess = photoIds => ({
  type: types.APPROVE_PENDING_PHOTO_SUCCESS,
  photoIds
});

const approvePhotosFailure = () => ({
  type: types.APPROVE_PENDING_PHOTO_FAILURE
});

/**
 * Reject provided photos
 * @param {PendingPhotoApproval[]} photoIds
 */
const rejectPhotosRequest = photoIds => ({
  type: types.REJECT_PENDING_PHOTO_REQUEST,
  photoIds
});

/**
 * Successful photo rejecting
 * @param {PendingPhotoApproval[]} photoIds
 */
const rejectPhotosSuccess = photoIds => ({
  type: types.REJECT_PENDING_PHOTO_SUCCESS,
  photoIds
});

const rejectPhotosFailure = () => ({
  type: types.REJECT_PENDING_PHOTO_FAILURE
});

/**
 * @param {String[]} keys - S3 keys
 * @param {String} filename - base name of the saved files
 */
const downloadPhotosRequest = (keys, filename = 'image') => ({
  type: types.DOWNLOAD_PHOTOS_REQUEST,
  keys,
  filename
});

const downloadPhotosSuccess = () => ({
  type: types.DOWNLOAD_PHOTOS_SUCCESS
});

const dowloadPhotosFailure = () => ({
  type: types.DOWNLOAD_PHOTOS_FAILURE
});

export default {
  getCenterGalleryInformationRequest,
  getCenterGalleryInformationSuccess,
  getCenterGalleryInformationFailure,
  getChildGalleryInformationRequest,
  getChildGalleryInformationSuccess,
  getChildGalleryInformationFailure,
  approvePhotosRequest,
  approvePhotosSuccess,
  approvePhotosFailure,
  rejectPhotosRequest,
  rejectPhotosSuccess,
  rejectPhotosFailure,
  downloadPhotosRequest,
  downloadPhotosSuccess,
  dowloadPhotosFailure
};
